<template>
    <div id="quoter-component">

        <b-modal @hide="closeModal" v-model="showModal" v-if="(role_id === 1 || role_id === 2)" id="modal-cotizador"
            hide-footer size="xl" centered scrollable :title="titleModal" ref="modal-serv">

            <ticket-quoter-client v-if="modalTicketQuoter" @close-modal="closeModal" :quoter_id="quoter_id_ticket"
                :approved_ad="approved_at" :renew="renew_status">
            </ticket-quoter-client>

            <upload-invoice v-if="modalBills" :role_id="role_id" :user_id="user_id" :type_invoice="0" :is_quoter="true"
                :is_sinister="false" :reg_id="quoting_id">
            </upload-invoice>

            <form v-if="modalForm" id="" class="formQuoter">
                <input type="hidden" name="totalPkg" id="totalPkg">
                <div class="row">
                    <div class="col-12">
                        <cite>*Campos requeridos con linea roja.</cite>
                    </div>
                </div>
                <h2 class="cabeza">Renovación</h2>
                <div class="row">
                    <div class="col-12 col-md-12">
                        <div class="alert alert-info">
                            Al marcar el checkbox le dira al sistema que esta cotización sera usada como la renovación
                            de un cliente.
                            <input style="float:right" class="float" v-model="quoter.renew" type="checkbox"
                                name="renovar" id="renovar">
                        </div>
                    </div>
                </div>

                <h2 class="cabeza">Datos del Cliente</h2>
                <div class="row">
                    <div class="col-12 col-md-4">

                        <select v-model="quoter.tipo_per" id="tipoPer" data-select="on" name="tipo_per" class="required"
                            v-on:change="tipoPer($event)">
                            <option :value="0">Tipo de Persona</option>
                            <option :value="1">Física</option>
                            <option :value="2">Moral</option>
                        </select>
                    </div>
                    <div class="col-12 col-md-4">
                        <p>
                            <input v-model="quoter.nom_cont" class="al-inputs scr-input" type="text" id="nombre"
                                name="nom_cont" data-name-input="Nombre Contratante/ Administrador Único"
                                placeholder="Nombre Contratante*" />
                            <label for="nombre" class="scr-supertext">Nombre Contratante*</label>
                        </p>
                    </div>
                    <div class="col-12 col-md-4">
                        <p>
                            <input v-model="quoter.paterno" class="al-inputs scr-input" type="text" id="paterno"
                                name="paterno" data-name-input="Apellido Paterno" placeholder="Apellido Paterno*" />
                            <label for="paterno" class="scr-supertext">Apellido Paterno*</label>
                        </p>
                    </div>
                    <div class="col-12 col-md-4">
                        <p>
                            <input v-model="quoter.materno" class="al-inputs scr-input" type="text" id="materno"
                                name="materno" data-name-input="Apellido Materno" placeholder="Apellido Materno*" />
                            <label for="materno" class="scr-supertext">Apellido Materno*</label>
                        </p>
                    </div>
                    <div class="col-12 col-md-4">
                        <p>
                            <input v-model="quoter.direccion" class="al-inputs scr-input" type="text" id="direccion"
                                name="direccion" data-name-input="Dirección" placeholder="Dirección*" />
                            <label for="direccion" class="scr-supertext">Dirección*</label>
                        </p>
                    </div>
                    <div class="col-12 col-md-4">
                        <p>
                            <input v-model="quoter.telefono" maxlength="10" class="al-inputs required scr-input"
                                type="number" id="telefono" name="telefono" data-name-input="Teléfono"
                                placeholder="Teléfono sin guinoes o parentesis*" />
                            <label for="telefono" class="scr-supertext">Teléfono sin guinoes o parentesis*</label>
                        </p>
                    </div>
                    <div class="col-12 col-md-4">
                        <p>
                            <input v-model="quoter.email" class="al-inputs required scr-input" type="text" id="correo"
                                name="email" data-name-input="E-mail" placeholder="E-mail*" />
                            <label for="correo" class="scr-supertext">E-mail*</label>
                        </p>
                    </div>
                    <div class="col-12 col-md-4">
                        <p>
                            <input v-model="quoter.nmComPerMoral" class="al-inputs scr-input" type="text"
                                id="nmComPerMoral" name="nmComPerMoral" data-name-input="Nombre Persona Moral"
                                placeholder="Nombre Persona Moral" />
                            <label for="nmComPerMoral" class="scr-supertext">Nombre Persona Moral</label>
                        </p>
                    </div>
                    <div class="col-12 col-md-4">
                        <p>
                            <input v-model="quoter.rfc" class="al-inputs scr-input" type="text" id="rfc" name="rfc"
                                data-name-input="Rfc" placeholder="Rfc" />
                            <label for="rfc" class="scr-supertext">Rfc</label>
                        </p>
                    </div>
                    <div class="col-12 col-md-4">
                        <select v-model="quoter.state_id" id="state_id" name="state_id" data-select="on"
                            class="required" v-on:change="selectCities($event)">
                            <option :value="0">Selecciona un estado</option>
                            <option v-for="edo in states" :value="edo.id">{{ edo.estado }}</option>
                        </select>
                    </div>
                    <div class="col-12 col-md-4">
                        <select v-model="quoter.cities_id" id="cities_id" name="cities_id" data-select="on"
                            class="required">
                            <option :value="0">Selecciona una ciudad</option>
                            <option v-for="city in cities" :value="city.id">{{ city.ciudad }}</option>
                        </select>
                    </div>
                </div>
                <h2 class="cabeza">Datos del Asesor</h2>
                <div class="row">
                    <div class="col-12 col-md-3">
                        <select v-model="quoter.promoter_id" v-on:change="selectAgents($event)"
                            :disabled="role_id !== 1" data-select="on" class="required" data-name-input="Promotor"
                            name="promoter_id" id="promotor_filtro">
                            <option :value="0">Selecciona un promotor</option>
                            <option v-for="promoter in promoters" :value="promoter.id">
                                {{ promoter.nmPromotor }}
                            </option>
                        </select>
                        <input type="hidden" v-model="quoter.promoter_id" name="" v-if="role_id !== 1">
                    </div>
                    <div class="col-12 col-md-3">
                        <select v-model="quoter.agent_id" v-on:change="infoAgent($event)" data-select="on"
                            class="required" :disabled="role_id !== 1" data-name-input="Agente" name="agent_id"
                            id="agente_filtro">
                            <option :value="0">Selecciona un agente</option>
                            <option v-for="agent in agents" :value="agent.id">
                                {{ agent.comisionista }}
                            </option>
                        </select>
                        <input type="hidden" v-model="quoter.agent_id" name="" v-if="role_id !== 1">
                    </div>
                    <div class="col-12 col-md-3">
                        <input v-model="quoter.tel_asesor" class="al-inputs required scr-input" type="text"
                            id="telAsesor" name="tel_asesor" data-name-input="Tel. Asesor" placeholder="Tel. Asesor*" />
                        <label for="telAsesor" class="scr-supertext">Tel. Asesor*</label>
                    </div>
                    <div class="col-12 col-md-3">
                        <input v-model="quoter.email_asesor" class="al-inputs required scr-input" type="text"
                            id="emailAsesor" name="email_asesor" data-name-input="Email Asesor"
                            placeholder="Email Asesor*" />
                        <label for="emailAsesor" class="scr-supertext">Email Asesor*</label>
                    </div>
                </div>
                <h2 class="cabeza">Planes y Financiamientos</h2>
                <div class="row align-items-center">
                    <div class="col-12 col-md-3">
                        <select v-model="quoter.package_id" id="package_id" v-on:change="selectPlans(quoter.package_id)"
                            data-select="on" class="required" data-name-input="Selecciona un Plan" name="package_id">
                            <option :value="0">Selecciona un Plan</option>
                            <option v-for="pack in packages" :value="pack.id">
                                {{ pack.paquete }}
                            </option>
                        </select>

                    </div>
                    <div class="col-12 col-md-3">
                        <select :disabled="!isKindPlanIdEnabled" v-model="quoter.kind_plan_id" id="kind_plan_id"
                            data-select="on" data-name-input="Selecciona un tipo de Paquete" name="kind_plan_id"
                            class="required" v-on:change="settingKindPlan($event)">
                            <option :value="0">Selecciona un tipo de Paquete</option>
                            <option v-for="kind in plans" :value="kind.id" :data-package-id="kind.package_id"
                                :data-min-per="kind.min_per" :data-kind-plan="kind.kind_plan"
                                :data-descuento="kind.descuento" :data-gasto="kind.gasto" :data-costo="kind.costo"
                                :data-vug="kind.vug" :data-r90="kind.r90">
                                {{ kind.plan }}
                            </option>
                        </select>
                    </div>
                    <div class="col-md-3">
                        <select :disabled="!isPercentIvaEnabled" data-select="on" data-name-input="Selecciona un iva"
                            v-model="quoter.percent_iva" name="iva" id="iva" class="required"
                            v-on:change="enableFields()">
                            <option :value="0">Selecciona un I.V.A.</option>
                            <option :value=".16">16%</option>
                            <!--                            <option :value=".08">.08%</option>-->
                        </select>
                    </div>
                    <div class="col-md-3">
                        <select :disabled="!isPagoIdEnabled" data-select="on"
                            data-name-input="Selecciona un Plan de Financiamiento" v-model="quoter.pago_id"
                            name="pago_id" id="pago_id" class="required" v-on:change="getMonths($event)">
                            <option :value="0">Plan de Financiamiento</option>
                            <option v-for="(pago, index) in pagos" :key="index" :value="pago.id"
                                :data-meses="pago.meses" :data-porcentaje="pago.porcentaje"
                                :data-visible="pago.visible_for">
                                {{ pago.nombre }}
                            </option>
                        </select>
                        <div v-if="showCustomMonth">
                            <input type="text" v-model="quoter.meses" name="meses" id="meses" class="required al-inputs"
                                placeholder="Meses">
                        </div>
                    </div>
                </div>

                <!--AFILIADOS QUE NO SON COLECTIVOS-->
                <h2 v-if="showAffiliates" class="cabeza">Afiliados</h2>
                <div v-if="showAffiliates" class="row afiliados">
                    <div class="col-md-3">
                        <div class="reservation-box">
                            <div class="person-counter">
                                <div class="titleCounter">Niños < 15</div>
                                        <button :disabled="activateFieldKids === false" type="button"
                                            class="button minus" v-on:click="decrement('kid')">-
                                        </button>
                                        <span class="amount">{{ quoter.kid }}</span>
                                        <button :disabled="activateFieldKids === false" type="button"
                                            class="button plus" v-on:click="increment('kid')">+
                                        </button>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="reservation-box">
                                <div class="person-counter">
                                    <div class="titleCounter">Embarazadas</div>
                                    <button :disabled="activateFieldsEmb === false" type="button" class="button minus"
                                        v-on:click="decrement('emb')">-
                                    </button>
                                    <span class="amount">{{ quoter.emb }}</span>
                                    <button :disabled="activateFieldsEmb === false" type="button" class="button plus"
                                        v-on:click="increment('emb')">+
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="reservation-box">
                                <div class="person-counter">
                                    <div class="titleCounter">Adultos > 15 y < 59 años</div>
                                            <button :disabled="activateFieldsAdult === false" type="button"
                                                class="button minus" v-on:click="decrement('adu')">-
                                            </button>
                                            <span class="amount">{{ quoter.adu }}</span>
                                            <button :disabled="activateFieldsAdult === false" type="button"
                                                class="button plus" v-on:click="increment('adu')">+
                                            </button>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="reservation-box">
                                    <div class="person-counter">
                                        <div class="titleCounter">Adultos > 59 años</div>
                                        <button :disabled="activateFieldsGranny === false" type="button"
                                            class="button minus" v-on:click="decrement('gran')">-
                                        </button>
                                        <span class="amount">{{ quoter.gran }}</span>
                                        <button :disabled="activateFieldsGranny === false" type="button"
                                            class="button plus" v-on:click="increment('gran')">+
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!--CAMPOS PARA COLECTIVOS-->
                        <h2 v-if="showCollectiveFields" class="cabeza">Colectivos</h2>
                        <div v-if="showCollectiveFields" class="row">
                            <div class="col-12 col-md-2">
                                <input v-model="quoter.num_titulares" id="num_titulares" name="num_titulares"
                                    class="al-inputs scr-input" type="text" placeholder="# de Titulares"
                                    @input="handleInput('num_titulares')" />
                                <label for="num_titulares" class="scr-supertext"># de Titulares</label>
                            </div>
                            <div class="col-12 col-md-2">
                                <input v-model="quoter.num_dependientes" id="num_dependientes" name="num_dependientes"
                                    class="al-inputs scr-input" type="text" placeholder="# de Dependientes"
                                    @input="handleInput('num_dependientes')" />
                                <label for="num_dependientes" class="scr-supertext"># de Dependientes</label>
                            </div>
                            <div class="col-12 col-md-2">
                                <input v-model="quoter.costo_x_persona" id="costo_x_persona" name="costo_x_persona"
                                    class="al-inputs scr-input" type="text" placeholder="Costo por Persona"
                                    @input="handleInput('costo_x_persona')" />
                                <label for="costo_x_persona" class="scr-supertext">Costo por Persona</label>
                            </div>
                            <div class="col-12 col-md-2">
                                <input v-model="quoter.costo_x_per_dcto" id="costo_x_per_dcto" name="costo_x_per_dcto"
                                    class="al-inputs scr-input" type="text" placeholder="Costo x per. c/dcto"
                                    @input="handleInput('costo_x_per_dcto')" />
                                <label for="costo_x_persona" class="scr-supertext">Costo x per. c/dcto</label>
                            </div>
                            <div class="col-12 col-md-2">
                                <input v-model="quoter.num_asegurados" id="num_asegurados" name="num_asegurados"
                                    class="al-inputs scr-input" type="text" placeholder="# de Asegurados"
                                    @input="handleInput('num_asegurados')" />
                                <label for="num_asegurados" class="scr-supertext"># de Asegurados</label>
                            </div>
                            <div class="col-12 col-md-2">
                                <input v-model="quoter.prima_base" id="prima_base" name="prima_base"
                                    class="al-inputs scr-input" type="text" placeholder="Costo Báse"
                                    @input="handleInput('prima_base')" />
                                <label for="prima_base" class="scr-supertext">Costo Báse</label>
                            </div>
                            <div class="col-12 col-md-2">
                                <input v-model="quoter.descuento" id="descuento" name="descuento"
                                    class="al-inputs scr-input" type="text" placeholder="Descuento"
                                    @input="handleInput('descuento')" />
                                <label for="descuento" class="scr-supertext">Descuento</label>
                            </div>
                            <div class="col-12 col-md-2">
                                <input v-model="quoter.gastos" id="gastos" name="gastos" class="al-inputs scr-input"
                                    type="text" placeholder="Gtos. Admin." @input="handleInput('gastos')" />
                                <label for="gastos" class="scr-supertext">Gtos. Admin.</label>
                            </div>
                            <div class="col-12 col-md-2">
                                <input v-model="quoter.gasto_x_persona" id="gasto_x_persona" name="gasto_x_persona"
                                    class="al-inputs scr-input" type="text" placeholder="Gto. por Persona"
                                    @input="handleInput('gasto_x_persona')" />
                                <label for="gasto_x_persona" class="scr-supertext">Gto. por Persona</label>
                            </div>
                            <div class="col-12 col-md-2">
                                <input v-model="quoter.amount_affiliate_extra_prima" id="amount_affiliate_extra_prima"
                                    name="amount_affiliate_extra_prima" class="al-inputs scr-input" type="text"
                                    placeholder="Extra Prima" @input="handleInput('amount_affiliate_extra_prima')" />
                                <label for="amount_affiliate_extra_prima" class="scr-supertext">Extra Prima</label>
                            </div>
                            <div class="col-12 col-md-2">
                                <input v-model="quoter.a_p" id="a_p" name="a_p" class="al-inputs scr-input" type="text"
                                    placeholder="A.P." @input="handleInput('a_p')" />
                                <label for="a_p" class="scr-supertext">A.P.</label>
                            </div>
                            <div class="col-12 col-md-2">
                                <input v-model="quoter.prima_neta" id="prima_neta" name="prima_neta"
                                    class="al-inputs scr-input" type="text" placeholder="Costo Neto."
                                    @input="handleInput('prima_neta')" />
                                <label for="prima_neta" class="scr-supertext">Costo Neto</label>
                            </div>
                            <div class="col-12 col-md-2">
                                <input v-model="quoter.subtotal" id="subtotal" name="subtotal"
                                    class="al-inputs scr-input" type="text" placeholder="Subtotal"
                                    @input="handleInput('subtotal')" />
                                <label for="subtotal" class="scr-supertext">Subtotal</label>
                            </div>
                            <div class="col-12 col-md-2">
                                <input v-model="quoter.iva" id="iva" name="iva" class="al-inputs scr-input" type="text"
                                    placeholder="I.V.A." @input="handleInput('iva')" />
                                <label for="iva" class="scr-supertext">I.V.A.</label>
                            </div>
                            <div class="col-12 col-md-2">
                                <input @blur="handleBlur" v-model="quoter.prima_total" id="prima_total"
                                    name="prima_total" class="al-inputs scr-input" type="text" placeholder="Prima Total"
                                    @input="handleInput('prima_total')" />
                                <label for="prima_total" class="scr-supertext">Prima Total</label>
                            </div>
                            <div class="col-12 col-md-2">
                                <input v-model="quoter.anticipo" id="anticipo" name="anticipo"
                                    class="al-inputs scr-input" type="text" placeholder="Anticipo"
                                    @input="handleInput('anticipo')" />
                                <label for="anticipo" class="scr-supertext">Anticipo</label>
                            </div>
                        </div>

                        <!-- TOTALES DE LA COTIZACIÓN -->
                        <div v-if="showTotales" class="row">
                            <div id="totales" class="col-12 col-sm-12">
                                <div class="row">

                                    <div class="col-12">
                                        <h2 class="cabeza">Totales</h2>
                                    </div>
                                    <div class="col-6">
                                        <div style="font-size:14px; text-align: center;">Desglosar de costos:</div>
                                        <div style="margin:auto; width:70px;">
                                            <input type="checkbox" v-model="quoter.apportionment" hidden="hidden"
                                                id="apportionment">
                                            <label class="switch" for="apportionment"></label>
                                        </div>
                                    </div>
                                    <div class="col-6">
                                        <div style="font-size:14px; text-align: center;">Dto. Campaña:</div>
                                        <div style="margin:auto; width:70px;">
                                            <input type="checkbox" @change="aplyDiscountCampain()"
                                                v-model="quoter.discount_campain" hidden="hidden" id="discount_campain">
                                            <label class="switch" for="discount_campain"></label>
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-12">
                                        <p>
                                            <label for="subTotal">Costo Base:</label>
                                        </p>
                                        <p>
                                            <input v-model="quoter.prima_base" id="prima_base" class="al-inputs"
                                                type="text" readonly name="prima_base" placeholder="Costo Base" />
                                        </p>
                                    </div>
                                    <div :class="[
                                        isFamilyQuoter ? 'col-12 col-md-6' : 'col-12 col-md-12',
                                        'extraPrima'
                                    ]" v-show="flagIndividual === true">
                                        <p>
                                            <label for="subTotal">Costo Extra:</label>
                                        </p>
                                        <p>
                                            <input v-model="quoter.extra_prima" id="extra_prima" class="al-inputs"
                                                type="text" readonly name="extra_prima" placeholder="Extra Prima" />
                                        </p>
                                    </div>

                                    <div class="col-12 col-md-6"
                                        v-show="isFamilyQuoter && isGranComponent && isValidMinPer">
                                        <p>
                                            <label for="subTotal">Dto. x Fam.:</label>
                                        </p>
                                        <p>
                                            <input v-model="quoter.desc_fam" id="desc_fam" class="al-inputs" type="text"
                                                readonly name="desc_fam" placeholder="Descuento x Fam." />
                                        </p>
                                    </div>
                                    <div class="col-12 col-md-6" v-show="flagIndividual === false">
                                        <p>
                                            <label for="prima_neta_desc">Cant. Dto. Fam.:</label>
                                        </p>
                                        <p>
                                            <input v-model="quoter.prima_neta_desc" id="prima_neta_desc"
                                                class="al-inputs" type="text" readonly name="prima_neta_desc"
                                                placeholder="Cant. Dto. Fam." />
                                        </p>
                                    </div>
                                    <div class="col-12 col-md-6 extraPrima" v-show="role_id === 1">
                                        <p>
                                            <label for="subTotal">Dto Personalizado:</label>
                                        </p>
                                        <p>
                                            <input v-model="quoter.descuento" id="descuento" class="al-inputs"
                                                type="text" v-on:keyup="customDiscount()" name="descuento"
                                                placeholder="Dto. Per." />
                                        </p>
                                    </div>
                                    <div class="col-12 col-md-4">
                                        <p>
                                            <label for="subTotal">Costo Neto:</label>
                                        </p>
                                        <p>
                                            <input v-model="quoter.prima_neta" id="prima_neta" class="al-inputs"
                                                type="text" readonly name="prima_neta" placeholder="Prima Neta" />
                                        </p>
                                    </div>
                                    <div class="col-12 col-md-4">
                                        <p>
                                            <label for="subTotal">Gastos:</label>
                                        </p>
                                        <p>
                                            <input v-model="quoter.gastos" id="gastos" class="al-inputs" type="text"
                                                readonly name="gastos" placeholder="Gastos" />
                                        </p>
                                    </div>

                                    <div class="col-12 col-md-4">
                                        <p>
                                            <label for="subTotal">Subtotal:</label>
                                        </p>
                                        <p>
                                            <input v-model="quoter.subtotal" id="subtotal" class="al-inputs" type="text"
                                                readonly name="subtotal" placeholder="Subtotal" />
                                        </p>
                                    </div>

                                    <div class="col-12 col-md-4">
                                        <p>
                                            <label for="subTotal">I.V.A:</label>
                                        </p>
                                        <p>
                                            <input v-model="quoter.iva" id="iva" class="al-inputs" type="text" readonly
                                                name="iva" placeholder="I.V.A" />
                                        </p>
                                    </div>

                                    <!--  <div class="col-12 col-md-4 extraPrima" v-show="quoter.financing_percentage!==0">
                                <p>
                                    <label for="subTotal">Inc. Finan.:</label>
                                </p>
                                <p>
                                    <input v-model="quoter.amount_financing" id="financiamiento" class="al-inputs" type="text" readonly name="descuento" placeholder="Inc. Financiamiento"/>
                                </p>
                            </div>-->

                                    <div class="col-12 col-md-4" v-if="planSelected == 14 || planSelected == 15">
                                        <p>
                                            <label for="subTotal">Vida y Últimos Gastos:</label>
                                        </p>
                                        <p>
                                            <input v-model="quoter.vug" id="financiamiento" class="al-inputs"
                                                type="text" readonly name="descuento"
                                                placeholder="Vida y Últimos Gastos" />
                                        </p>
                                    </div>
                                    <div class="col-12 col-md-4" v-if="planSelected == 14 || planSelected == 15">
                                        <p>
                                            <label for="subTotal">Recupera 90:</label>
                                        </p>
                                        <p>
                                            <input v-model="quoter.r90" id="financiamiento" class="al-inputs"
                                                type="text" readonly name="descuento" placeholder="Recupera 90" />
                                        </p>
                                    </div>
                                    <div class="col-12 col-md-4">
                                        <p>
                                            <label for="subTotal">TOTAL:</label>
                                        </p>
                                        <p>
                                            <input v-model="quoter.prima_total" id="prima_total" class="al-inputs"
                                                type="text" readonly name="prima_total" placeholder="PRIMA TOTAL" />
                                        </p>
                                    </div>
                                </div>
                            </div>

                        </div>

                        <!-- TOTALES DE LA CLIP -->
                        <div v-if="showClipFields" class="row">
                            <h2 class="cabeza">FINANCIAMIENTOS</h2>
                            <div class="col-12 col-sm-2 offset-sm-1">
                                <label for="">Contado</label>
                                <input type="text" v-model="quoter.cash_total" readonly id="" class="al-inputs">
                            </div>
                            <div class="col-12 col-sm-2">
                                <label for="">3 meses</label>
                                <input type="text" v-model="quoter.total_3_months" readonly id="" class="al-inputs">
                                <input type="text" v-model="quoter.monthly_payment_of_3_msi" readonly id=""
                                    class="al-inputs">
                            </div>
                            <div class="col-12 col-sm-2">
                                <label for="">6 meses</label>
                                <input type="text" v-model="quoter.total_6_months" readonly id="" class="al-inputs">
                                <input type="text" v-model="quoter.monthly_payment_of_6_msi" readonly id=""
                                    class="al-inputs">
                            </div>
                            <div class="col-12 col-sm-2">
                                <label for="">9 meses</label>
                                <input type="text" v-model="quoter.total_9_months" readonly id="" class="al-inputs">
                                <input type="text" v-model="quoter.monthly_payment_of_9_msi" readonly id=""
                                    class="al-inputs">
                            </div>
                            <div class="col-12 col-sm-2">
                                <label for="">12 meses</label>
                                <input type="text" v-model="quoter.total_12_months" readonly id="" class="al-inputs">
                                <input type="text" v-model="quoter.monthly_payment_of_12_msi" readonly id=""
                                    class="al-inputs">
                            </div>
                        </div>
                        <h2 class="cabeza">Notas Extras</h2>
                        <div class="row">
                            <div class="col-12">
                                <editor v-model="quoter.nota" plugins="lists advlist"
                                    toolbar="bold italic | alignleft aligncenter alignright | bullist numlist | link image media | insertdatetime | code codesample" />
                            </div>
                        </div>
                        <!-- BTN GUARDAR -->
                        <div class="row">
                            <div class="col-12">
                                <button id="dyn-button" type="button" class="formSubmit" v-on:click="guardar">Guardar
                                    Cotización
                                </button>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <cite>Campos obligatorios*</cite>
                            </div>
                        </div>
            </form>
        </b-modal>

        <main id="mainContent" class="padFixBoth">
            <div class="view">
                <div class="barSettings">
                    <div class="row">
                        <div class="col-12 col-xl-3 mb-3 mb-sm-0">
                            <b-pagination pills align="fill" :hide-goto-end-buttons="true" :limit="3"
                                v-model="pagination.current_page" :total-rows="pagination.total"
                                :per-page="pagination.per_page" aria-controls="my-table"
                                v-on:change="onChange"></b-pagination>
                        </div>
                        <div class="col-12  col-xl-5 mb-3 mb-sm-0">
                            <input id="filter-input" class="al-inputs scr-input" v-model="filter" type="search"
                                placeholder="Buscar por palabra">
                            <label for="filter-input" class="scr-supertext scr-extra">Buscar por palabra</label>
                        </div>
                        <div class="col-12  col-xl-2 mb-3 mb-sm-0 cont_select">
                            <select id="change_result" class="float" v-model="params.limit" v-on:change="changeLimit">
                                <option :value="10">10</option>
                                <option :value="20">20</option>
                                <option :value="30">30</option>
                                <option :value="50">50</option>
                                <option :value="100">100</option>
                            </select>
                        </div>
                        <div class="col-12 col-xl-2 mb-3 mb-sm-0" v-if="(role_id === 1 || role_id === 2)">
                            <button class="formSubmit" type="button" v-on:click="openModalsProviders('quoter')"> Cotizar
                            </button>
                        </div>
                    </div>
                </div>
                <div class="container-fluid">
                    <div class="row">
                        <b-table stacked="md" id="my-table" striped hover :fields="fields" :busy="isBusy"
                            :items="pagination.data" :filter="filter">
                            <template #head(acciones)="{ item }">
                                <i class="fa-solid fa-gear"></i>
                            </template>
                            <template #cell(nombre)="{ item }">
                                <div v-if="item.tipo_per == 1" style="text-align: left; padding-left:15px;">
                                    <span v-if="item.web == 1"><i class="fa-solid fa-globe"></i></span> {{
                                        item.nom_cont
                                    }}
                                    {{ item.paterno }} {{ item.materno }}
                                </div>
                                <div v-else style="text-align: left; padding-left:15px;"> {{ item.nmComPerMoral }}</div>
                            </template>
                            <template #cell(pago)="{ item }">
                                <span v-if="item.relpago" class="badge rounded-pill text-bg-blue">
                                    {{ item.relpago.nombre }}
                                </span>
                            </template>
                            <template #cell(paquete)="{ item }">
                                <span v-if="item.relpackage" class="badge rounded-pill text-bg-teal">
                                    {{ item.relpackage.paquete }}
                                </span>
                            </template>
                            <template #cell(plan)="{ item }">
                                <span v-if="item.reltipoplan" class="badge rounded-pill text-bg-purple">
                                    {{ item.reltipoplan.plan }}
                                </span>
                            </template>
                            <template #cell(total)="{ item }">
                                {{ formatPrice(item.prima_total) }}
                            </template>
                            <template #cell(fecha)="{ item }">
                                {{ formatDate(item.fecha) }}
                            </template>
                            <template #cell(status)="{ item }">
                                <span v-if="item.approved_at != null" class="badge rounded-pill text-bg-success"><i
                                        class="fa-solid fa-circle-check"></i></span>
                                <span v-else class="badge rounded-pill text-bg-orange"><i
                                        class="fa-solid fa-circle-exclamation"></i></span>
                            </template>
                            <template #cell(pdf)="{ item }">

                                <a v-if="item.pdf != null" :href="path_storage + item.pdf"
                                    class="badge rounded-pill text-bg-blue" target="_blank">
                                    <i class="fas fa-file-pdf"></i>
                                </a>

                                <span v-else></span>
                            </template>
                            <template #cell(acciones)="{ item }">
                                <div class="dropdown">
                                    <button class="btn btn-warning dropdown-toggle" type="button"
                                        id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true"
                                        aria-expanded="false">
                                        <i class="fas fa-cogs"></i>
                                    </button>
                                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                        <a class="dropdown-item" v-if="role_id === 1" href="javascript:void(0)"
                                            v-on:click="approved_quoter(item)">Aprobar</a>
                                        <a class="dropdown-item" v-if="role_id === 1" href="javascript:void(0)"
                                            v-on:click="modificar = true; edit_quoter(item)">Editar</a>
                                        <a class="dropdown-item" href="javascript:void(0)"
                                            v-on:click="print_pdf(item.id)">
                                            Imprimir
                                        </a>
                                        <a class="dropdown-item" v-if="item.approved_at !== null"
                                            href="javascript:void(0)" v-on:click="uploadInvoice(item.id)">
                                            Subir Factura
                                        </a>
                                        <a class="dropdown-item" href="javascript:void(0)"
                                            v-on:click="onClickDelete(item.id)">
                                            Borrar
                                        </a>
                                    </div>
                                </div>
                            </template>
                            <template #table-busy>
                                <div class="text-center text-danger my-2">
                                    <b-spinner class="align-middle"></b-spinner>
                                    <strong>Loading...</strong>
                                </div>
                            </template>
                        </b-table>
                        <div class="col-12 col-xl-2">
                            <b-pagination pills align="fill" :hide-goto-end-buttons="true" :limit="3"
                                v-model="pagination.current_page" :total-rows="pagination.total"
                                :per-page="pagination.per_page" aria-controls="my-table"
                                v-on:change="onChange"></b-pagination>
                        </div>
                    </div>
                </div>
            </div>

        </main>

    </div>
</template>
<script>
import { myMixins } from "../mixins/myMixins";
import { estadoService } from "../../Services/States.service";
import { promotersService } from "../../Services/Promoters.service";
import { agentsService } from "../../Services/Agents.service";
import { packagesService } from "../../Services/Packages.service";
import { paymentplanService } from "../../Services/Paymentplan.service";
import { plansService } from "../../Services/Plans.service";
import { quotersService } from "../../Services/Quoters.service";
import { statescitiesService } from "../../Services/Statescities.service";
import { clientsService } from "../../Services/Clients.service";
import Editor from '@tinymce/tinymce-vue'

export default {
    name: "quoter",
    components: {
        'editor': Editor
    },
    mixins: [myMixins],
    props: {
        user_id: {
            type: Number,
            required: true
        },
        role_id: {
            type: Number,
            required: true
        },
    },
    data() {
        return {
            isKindPlanIdEnabled: false,
            isPercentIvaEnabled: false,
            isPagoIdEnabled: false,
            isFamilyQuoter: false,
            showCustomMonth: false,
            showTotales: false,
            showCollectiveFields: false,
            showClipFields: false,
            showAffiliates: false,
            showModal: false,
            showModGran: false,
            flagGran: false,
            flagIndividual: false,
            isGranComponent: false,
            isValidMinPer: false,
            isBusy: false,
            modificar: false,
            filter: null,
            activateFieldKids: true,
            activateFieldsEmb: true,
            activateFieldsAdult: true,
            activateFieldsGranny: true,
            renew_status: 0,
            quoter: {
                discount_campain: false,
                nota: '',
                wellmedic: '',
                saluddigna: '',
                state_id: 0,
                cities_id: 0,
                promoter_id: 0,
                agent_id: 0,
                package_id: 0,
                kind_plan_id: 0,
                pago_id: 0,
                tipo_per: 0,
                nom_cont: '',
                paterno: '',
                materno: '',
                direccion: '',
                telefono: '',
                email: '',
                nmComPerMoral: '',
                rfc: '',
                tel_asesor: '',
                email_asesor: '',
                num_afil: 0,
                costo_x_persona: 0,
                costo_x_per_dcto: 0,
                percent_iva: 0,
                financing_percentage: 0,
                prima_base: '',
                extra_prima: '',
                desc_fam: '',
                prima_neta_desc: '',
                prima_neta: '',
                gastos: '',
                gasto_x_persona: '',
                subtotal: '',
                iva: '',
                prima_total: '',
                prima_total_clip: '',
                kid: 0,
                emb: 0,
                adu: 0,
                gran: 0,
                prima_base_am: 0,
                extra_prima_am: 0,
                desc_fam_am: 0,
                prima_neta_am: 0,
                gastos_am: 0,
                subtotal_am: 0,
                iva_am: 0,
                prima_total_am: 0,
                num_titulares: '',
                num_dependientes: '',
                num_asegurados: '',
                descuento: '',
                a_p: '',
                financiamiento: '',
                anticipo: '',
                renovar: '',
                client_id: 0,
                meses: 0,
                visible_for: 0,
                add_gran: 0,
                amount_financing: 0,
                monthly_payment: 0,
                payment_date: '',
                start_date: '',
                end_date: '',
                cash_total: 0,
                total_3_months: 0,
                monthly_payment_of_3_msi: 0,
                monthly_payment_of_6_msi: 0,
                total_6_months: 0,
                monthly_payment_of_9_msi: 0,
                total_9_months: 0,
                monthly_payment_of_12_msi: 0,
                total_12_months: 0,
                apportionment: false,
                amount_affiliate_extra_prima: 0
            },
            quoter_id_ticket: 0,
            approved_at: false,
            params: {
                limit: 10,
                page: 1,
                where: []
            },
            pagosParams: {
                where: []
            },
            fields: [
                { key: 'Nombre' },
                { key: 'pago' },
                { key: 'paquete' },
                { key: 'plan' },
                { key: 'total' },
                { key: 'fecha' },
                { key: 'status' },
                { key: 'pdf' },
                { key: 'acciones' },
            ],
            pagination: {
                current_page: 1,
                data: [],
                first_page_url: '',
                from: 0,
                last_page: 0,
                last_page_url: '',
                links: [],
                next_page_url: '',
                path: '',
                per_page: 0,
                prev_page_url: '',
                to: 0,
                total: 0,
            },
            setKindPlan: {
                id: 0,
                package_id: '',
                min_per: '',
                kind_plan: '',
                descuento: 0,
                gasto: 0,
                vug: 0,
                r90: 0,
            },
            states: [],
            cities: [],
            promoters: [],
            agents: [],
            packages: [],
            plans: [],
            pagos: [],
            clients: [],
            kindFiled: '',
            planSelected: '',
            min_p: 0,
            itemId: 0,
            users_count: 0,
            quoting_id: 0,
            path_storage: '../storage/quotings/',
            _global_component: '',
            clip_budget: false,
            listPagosClip: [{ id: 4, meses: 0, porcentaje: 0 },
            { id: 2, meses: 3, porcentaje: 0.05 },
            { id: 3, meses: 6, porcentaje: 0.075 },
            { id: 10, meses: 9, porcentaje: 0.10 },
            { id: 1, meses: 12, porcentaje: 0.125 }],
            _incrementedValue: 0,
            _percentIncrement: 0,
            _costo_total: 0,
            _monthlyPayments: 0,
            _pb: 0,
            _gasto: 0,
            _iva: 0,
            _percent_increment: 0,
            _sumPercentRule: 0,
            _prima_neta: 0,
            _subTotal: 0,
            _calDescPb: 0,
            _calPercentDesc: 0,
            _iva_subtotal: 0,
            _customOrder: [4, 2, 3, 10, 1]
        }
    },
    methods: {
        // Helper function para redondear hacia arriba eliminando centavos
        roundUpToInteger(value) {
            return Math.ceil(Number(value));
        },
        async edit_quoter(data = {}) {
            //console.log(data);
            if (this.modificar) {
                this.tituloBtn = 'Actualizar'
                await this.selectPlans(data.package_id);
                await this.selectCities(data.state_id);
                await this.selectAgents(data.promoter_id);
                //this.getInfoPagoIdInEdit(data.pago_id);
                this.getInfoPlanSelectedInEdit(data.kind_plan_id);
                this.users_count = +data.kid + +data.emb + +data.adu + +data.gran;
                this.quoter = data;
                //YA NO SERA CLIP HAY QUE CAMBIARLO A STRIPE/MSI
                if (data.pago_id == 12) {
                    this.showClipFields = true;
                }

                this.openModalsProviders('quoter');
            } else {
                this.tituloBtn = 'Agregar';
                this.setEmpty();
            }
        },
        async onClickDelete(id) {
            let resp = '';
            resp = await quotersService.deleteOne(id);
            this.getAlert(resp.process);
            await this.index();
        },
        async guardar() {
            let resp = '';

            if (this.showCollectiveFields) {
                //FORMATEANDO LAS CANTIDADES CUANDO SON COLECTIVOS
                this.quoter.costo_x_persona = this.formatPrice(this.quoter.costo_x_persona);
                this.quoter.prima_base = this.formatPrice(this.quoter.prima_base);
                this.quoter.prima_neta = this.formatPrice(this.quoter.prima_neta);
                this.quoter.gastos = this.formatPrice(this.quoter.gastos);
                this.quoter.gasto_x_persona = this.formatPrice(this.quoter.gasto_x_persona);
                this.quoter.subtotal = this.formatPrice(this.quoter.subtotal);
                this.quoter.iva = this.formatPrice(this.quoter.iva);
                this.quoter.prima_total = this.formatPrice(this.quoter.prima_total);
                this.quoter.anticipo = this.formatPrice(this.quoter.anticipo);
            }

            let respVal = this.valFormulariosV3('formQuoter');
            if (this.users_count > 0 || this.quoter.num_asegurados > 0) {
                if (respVal) {
                    //this.disableSubmitBtn(true);
                    if (this.modificar) {
                        //console.log('actualizar', this.quoter);
                        resp = await quotersService.updateOne(this.quoter.id, this.quoter);
                    } else {
                        //console.log('guardar');
                        this.quoter.num_afil = this.users_count;
                        resp = await quotersService.saveOne(this.quoter);
                        //console.log(JSON.stringify(this.quoter));
                    }
                    this.getAlert(resp.process, true);
                    this.modificar = false;
                    this.showModal = false;
                    this.setEmpty();
                    await this.index();
                    //this.disableSubmitBtn(false);
                }
            } else {
                this.getAlert('no_affiliate');
            }
            //this.modificar = false;
        },
        async selectCities($e) {
            let state_id = this.stateId($e);
            this.cities = await statescitiesService.getCitiesByState(state_id);
        },
        async selectPlans(package_selected) {
            this.isKindPlanIdEnabled = true;
            this.planSelected = package_selected;

            let plans = await plansService.getPlansByPackage(package_selected);

            // Filtrar planes para roles 2 y 5
            if (this.role_id === 2 || this.role_id === 5) {
                plans = plans.filter(plan => !plan.plan.startsWith('C'));
            }

            this.plans = plans;
        },
        async selectAgents($e) {
            let promoter_id = this.stateId($e);
            this.agents = await agentsService.getAgentByPromoterId(promoter_id);
        },
        async index() {
            switch (this.role_id) {
                case 2:
                    let agent;
                    this.params.where.push({
                        field: 'agent_id',
                        operator: '=',
                        value: this.user_id
                    });
                    agent = await this.infoAgent(this.user_id);
                    await this.selectAgents(agent.promoter_id);
                    this.quoter.promoter_id = agent.promoter_id;
                    this.quoter.agent_id = agent.id;
                    this.pagosParams.where = [{
                        field: 'visible_for',
                        operator: '=',
                        value: this.role_id
                    }];
                    break;
            }
            this.isBusy = true;
            await this.dynamicInfo();
            this.clients = await clientsService.getMany({ limit: 0 });
            this.pagination = await quotersService.getMany(this.params);
            //SAVING ONLY CLIP PAYMENTS INTO listPagosClip CHECK IF porcentaje Column is not 0.00

            /*this.listPagosClip.sort((a, b) => {
                const idA = a.id;
                const idB = b.id;

                const indexA = customOrder.indexOf(idA);
                const indexB = customOrder.indexOf(idB);

                return indexA - indexB;
            });*/
            //console.log('listPagosClip=', this.listPagosClip);
            this.isBusy = false;
        },
        async infoAgent($e) {
            let agent_id = this.stateId($e);
            let infoUser = await agentsService.getOne(agent_id);
            this.quoter.tel_asesor = infoUser.telefono;
            this.quoter.email_asesor = infoUser.reluser.email;
            return infoUser;
        },
        async dynamicInfo() {
            this.states = await estadoService.getMany({ limit: 0 });
            this.promoters = await promotersService.getMany({ limit: 0 });
            this.packages = await packagesService.getMany({ limit: 0 });
            this.pagos = await paymentplanService.getMany(this.pagosParams);
        },
        async print_pdf(id) {
            this.isBusy = true;
            let resp = await quotersService.printQuote(id);
            this.getAlert(resp.process);
            this.pagination = await quotersService.getMany(this.params);
            this.isBusy = false;
        },
        activateFieldQuoter(min_per) {
            switch (min_per) {
                case 4:
                case 5:
                    //console.log('es un plan familar');
                    this.showAffiliates = true;
                    this.showTotales = true;
                    this.showCollectiveFields = false;
                    //HAGO UN SPLIT DE COLUMNAS PARA LOS USUARIOS NORMALES DEL PAQUETE Y LOS USUARIOS ADICIONALES DEL PAQUETE
                    break;

                case 6:
                case 20:
                case 101:
                case 301:
                case 501:
                case 1001:
                    this.quoter.num_asegurados = this.setKindPlan.min_per;
                    this.quoter.prima_base = this.setKindPlan.costo;
                    this.quoter.descuento = this.setKindPlan.descuento;
                    this.quoter.gastos = this.setKindPlan.gasto;
                    this.showTotales = false;
                    this.showAffiliates = false;
                    this.showCollectiveFields = true;
                    break;
                case 1:
                    this.flagIndividual = true;
                    this.showTotales = true;
                    this.showAffiliates = true;
                    this.showCollectiveFields = false;
                    break;
                default:
                    this.showTotales = true;
                    this.showAffiliates = true;
                    this.showCollectiveFields = false;

                    break;
            }
        },
        aplyDiscountCampain() {
            this.calculatePrice(this._global_component);
        },
        approved_quoter(item) {
            //console.log(item);
            this.quoter_id_ticket = item.id;
            this.renew_status = item.renew;
            (item.approved_at !== null) ? this.approved_at = true : this.approved_at = false;
            this.openModalsProviders('ticket_quoter');
        },
        calculateCustomDiscount(_pn) {
            const discountedAmount = _pn - ((_pn) * (Number(this.quoter.descuento) / 100));
            return this.roundUpToInteger(discountedAmount);
        },
        calculateClip(xtra) {
            //console.log('1040-xtra clip=', xtra);
            //PORCENTAJE DE CLIP -0.8196
            this._incrementedValue = this.roundUpToInteger((this._subTotal + this._iva_subtotal) + Number(xtra));
            this._percentIncrement = Number((this.quoter.financing_percentage / 100));

            this._costo_total = this.roundUpToInteger(this._incrementedValue / (1 - this._percentIncrement));
            //console.log('financing_percentage', this.quoter.financing_percentage, '_percentIncrement', this._percentIncrement, 'la resta= ', (1 - this._percentIncrement), '_incrementedValue', this._incrementedValue, '_costo_total', this._costo_total, 'xtra', xtra);
            this._monthlyPayments = this.roundUpToInteger(this._costo_total / this.quoter.meses);

        },
        calculateFamilyPrima({ minPer, kid, emb, adu, gran, percentIncrement, basePrima }) {

            let extraPrimaTotal = 0;
            let total = 0;
            const baseAmount = basePrima / minPer;

            // Calcula cuántos integrantes llevan extra prima
            const integrantesConExtra = (Number(kid) || 0) + (Number(emb) || 0) + (Number(gran) || 0);

            // Aplica extra prima a cada integrante que corresponde
            for (let i = 0; i < minPer; i++) {
                if (i < integrantesConExtra) {
                    const extra = this.roundUpToInteger(baseAmount * percentIncrement);
                    extraPrimaTotal += extra;
                    total += baseAmount + extra;
                } else {
                    total += baseAmount;
                }
            }

            return {
                primaNeta: this.roundUpToInteger(total),
                extraPrimaTotal: this.roundUpToInteger(extraPrimaTotal)
            };

        },

        calculatePrice(component) {
            //console.log('calculatePrice-component=', component, 'quoter[component]', this.quoter[component]);
            let vug = 0;
            let r90 = 0;
            let xtraD = 0;
            let totalCost = 0;
            let discountByCampain = 0;
            this._global_component = component;
            this._pb = Number(this.setKindPlan.costo);
            this._gasto = Number(this.setKindPlan.gasto);
            this._iva = this.quoter.percent_iva;
            this._percent_increment = 0;
            this._sumPercentRule = 0;
            this._prima_neta = 0;
            this._subTotal = 0;
            //variables para FAMILIARES
            this._calDescPb = 0;
            this._calPercentDesc = (Number(this.setKindPlan.descuento) / 100);
            this._iva_subtotal = 0;
            //console.log('setKindPlan.package_id',this.setKindPlan.package_id);
            if (this.setKindPlan.package_id == 14 || this.setKindPlan.package_id == 15) {
                //console.log('1072-diamantes');
                vug = Number(this.setKindPlan.vug);
                r90 = Number(this.setKindPlan.r90);

                /* if (this.setKindPlan.min_per > 1) {
                    vug = Number(vug) * Number(this.setKindPlan.min_per);
                    r90 = Number(r90) * Number(this.setKindPlan.min_per);
                } */
                //console.log('1080-vug-', vug, 'r90-', r90);
                this.quoter.vug = this.formatPrice(vug);
                this.quoter.r90 = this.formatPrice(r90);
                xtraD = Number(vug) + Number(r90);
            }

            //CALCULOS NORMALES DE LA COTIZACIÓN
            if (this.quoter.percent_iva !== 0) {

                switch (Number(this.setKindPlan.kind_plan)) {
                    case 1:
                        //CALCULOS PARA INDIVIDUAL
                        //OCULTA O MUESTRA LOS CAMPOS PARA LOS TOTALES
                        this.flagIndividual = true;
                        this._percent_increment = .75;
                        if (this._iva > 0) {
                            this._pb = this._pb * this.users_count;
                            this._gasto = this._gasto * this.users_count;

                            //PRIMERO LE CALCULAMOS EL .75 QUE ES LO QUE SE LE VA A INCREMENTAR A LA COSTO DEL SERVICIO ( PRIMA BASICA = PB )
                            this._sumPercentRule = this.roundUpToInteger(this._pb * this._percent_increment);

                            //SE LE INCREMENTA EL .75 A LA PRIMA BASICA
                            if (component === 'kid' || component === 'emb' || component === 'gran') {
                                this._prima_neta = this.roundUpToInteger(this._pb + this._sumPercentRule);
                            } else {
                                this._prima_neta = this.roundUpToInteger(this._pb);
                            }

                            if (this.quoter.descuento !== 0) {
                                this._prima_neta = this.calculateCustomDiscount(this._prima_neta);
                            }

                            //SE CALCULA EL IVA QUE SE SELECIONO PARA EL SERVICIO
                            this._iva_subtotal = this.roundUpToInteger((this._prima_neta + this._gasto) * this._iva);

                            //SE CALCULA EL SUBTOTAL
                            this._subTotal = this.roundUpToInteger(this._prima_neta + this._gasto);
                            //console.log('_subTotal-1028 =', _subTotal);
                            //DESHABILITANDO CAMPOS
                            switch (component) {

                                case 'kid':
                                    if (this.quoter.kid > 0 && this.quoter.kid === 1) {
                                        this.activateFieldsEmb = false;
                                        this.activateFieldsAdult = false;
                                        this.activateFieldsGranny = false;
                                    } else {

                                        if (this.quoter.kid === 0 || this.quoter.kid === '') {
                                            this.enableFields();
                                        }

                                    }
                                    break;
                                case 'emb':
                                    if (this.quoter.emb > 0 && this.quoter.emb === 1) {
                                        this.activateFieldKids = false;
                                        this.activateFieldsAdult = false;
                                        this.activateFieldsGranny = false;
                                    } else {

                                        if (Number(this.quoter.emb) === 0 || this.quoter.emb === '') {
                                            this.enableFields();
                                        }

                                    }
                                    break;
                                case 'gran':
                                    if (this.quoter.gran > 0 && this.quoter.gran === 1) {
                                        this.activateFieldKids = false;
                                        this.activateFieldsEmb = false;
                                        this.activateFieldsAdult = false;
                                    } else {
                                        if (this.quoter.gran === 0 || this.quoter.gran === '') {
                                            this.enableFields();
                                        }
                                    }
                                    break;
                                default:
                                    if (this.quoter.adu > 0 && this.quoter.adu === 1) {
                                        this.activateFieldKids = false;
                                        this.activateFieldsEmb = false;
                                        this.activateFieldsGranny = false;
                                    } else {

                                        if (this.quoter.adu === 0 || this.quoter.adu === '') {
                                            this.enableFields();
                                        }

                                    }
                                    break;

                            }

                        }
                        break;
                    case 2:

                        //CALCULOS PARA FAMILIAR
                        this.flagIndividual = false;
                        this._percent_increment = .75;
                        this.isFamilyQuoter = true;
                        //DISCOUNT FOR CAMPAIN


                        if (this._iva > 0) {

                            //CALCULO EL DESCUENTO  A LA PRIMA BASICA SEGUN EL PORCENTAJE DEL PAQUETE FAMILIAR
                            this._calDescPb = this.roundUpToInteger(this._pb * this._calPercentDesc);

                            //la cantidad de descunto familiar 
                            this.quoter.desc_fam = this.formatPrice(this._calDescPb);

                            //ESTE SERIA EL PRIMA NETA SIN GASTO RESTANDO LA CANTIDAD DEL DESCUENTO FAMILIAR
                            this._prima_neta = this.roundUpToInteger(this._pb - this._calDescPb);

                            if (this.quoter.discount_campain) {
                                //console.log('Descuento por campaña aplicado');
                                discountByCampain = (Number(10) / 100);
                                this._prima_neta = this.roundUpToInteger(this._prima_neta - (this._prima_neta * discountByCampain));
                            }

                            if (
                                Number(this.setKindPlan.kind_plan) === 2 &&
                                (this.setKindPlan.min_per == 2 || this.setKindPlan.min_per == 3)
                            ) {
                                const minPer = Number(this.setKindPlan.min_per);
                                const kid = Number(this.quoter['kid'] || 0);
                                const adu = Number(this.quoter['adu'] || 0);
                                const emb = Number(this.quoter['emb'] || 0);
                                const gran = Number(this.quoter['gran'] || 0);
                                const percentIncrement = this._percent_increment;
                                const basePrima = this._prima_neta;

                                //console.log('minPer:', minPer, 'kid:', kid, 'adu:', adu, 'gran:', gran, 'percentIncrement:', percentIncrement, 'basePrima:', basePrima);

                                const { primaNeta, extraPrimaTotal } = this.calculateFamilyPrima({
                                    minPer, kid, emb, adu, gran, percentIncrement, basePrima
                                });

                                this._prima_neta = primaNeta;
                                this._sumPercentRule = extraPrimaTotal;
                                this.quoter.extra_prima = this.formatPrice(this._sumPercentRule);

                                //console.log('primaNeta:', primaNeta, 'extraPrimaTotal:', extraPrimaTotal);
                            }

                            if (this.quoter.descuento !== 0) {
                                this._prima_neta = this.calculateCustomDiscount(this._prima_neta);
                            }

                            //EL SUBTOTAL ES EL PRIMA NETA + EL GASTO
                            this._subTotal = this.roundUpToInteger(this._prima_neta + this._gasto);

                            //console.log('_subTotal-1113 =', _subTotal);
                            //SE CALCULA EL IVA DEL SUBTOTAL
                            this._iva_subtotal = this.roundUpToInteger(this._subTotal * this._iva);

                        }
                        break;
                    case 3:
                        //CALCULOS PARA COLECTIVO
                        this.flagIndividual = false;
                        this._pb = Number(this.quoter.prima_base);
                        this._gasto = Number(this.quoter.gastos);
                        //SE DEBE CALCULAR EL COSTO NETO DEL SERVICIO
                        this._calDescPb = this.roundUpToInteger(this._pb * this._calPercentDesc);
                        //console.log('_pb=', this._pb, '_gasto=', this._gasto, '_calPercentDesc=', this._calPercentDesc, '_calDescPb=', this._calDescPb);
                        //console.log('_calDescPb = ', _calDescPb, ' _pb = ', _pb, ' _calPercentDesc = ', _calPercentDesc);
                        //ESTE SERIA EL PRIMA NETA SIN GASTO
                        this._prima_neta = this.roundUpToInteger(this._pb - this._calDescPb);
                        this._subTotal = this.roundUpToInteger(this._prima_neta + this._gasto);
                        this._iva_subtotal = this.roundUpToInteger(this._subTotal * this._iva);
                        this.quoter.prima_neta = this.roundUpToInteger(this._subTotal + this._iva_subtotal);
                        //console.log('Subtotal', this._subTotal, 'iva_subtotal=', this._iva_subtotal, 'prima_neta=', this.quoter.prima_neta, 'prima_neta=', this._prima_neta, '_gasto=', this._gasto, '_iva=', this._iva);
                        //console.log('calculando colectivo', this._subTotal, this._iva_subtotal, this.quoter.prima_neta);
                        break;
                }

                this.quoter.prima_base = this.formatPrice(this.roundUpToInteger(this._pb));
                this.quoter.gastos = this.formatPrice(this.roundUpToInteger(this._gasto));

                if (this.flagIndividual && component === 'kid' || this.flagIndividual && component === 'emb' || this.flagIndividual && component === 'gran') {
                    this.quoter.extra_prima = this.formatPrice(this.roundUpToInteger(this._sumPercentRule));
                } else {
                    this.quoter.prima_neta_desc = this.formatPrice(this.roundUpToInteger(this._calDescPb));
                }
                //COMIENZA EL CARGO DE LOS CAMPOS DE strip
                if (this.clip_budget === true) {

                    //console.log('listPagosClip = ', this.listPagosClip);
                    this.feedFieldsStripe(xtraD);
                    //AQUI VAMOS AGREGAR EL IF PAR EL VUG Y EL R90 setKindPlan.package_id si es igual a 14 y 15 se debe aplicar a la prima_total
                    totalCost = this.roundUpToInteger(this._subTotal + this._iva_subtotal);
                    this.quoter.prima_total = this.formatPrice(this.roundUpToInteger(totalCost + xtraD));

                } else {
                    //ASIGNACION DE VALORES FINALES DE LA COTIZACIÓN
                    if (this.quoter.financing_percentage !== 0) {
                        //console.log('1242-xtra antes de calculateClip', xtra);
                        //this.calculateClip(xtra);
                        //this.calculateStripe(_orgCost, pago.meses, xtra);
                        //console.log('_incrementedValue=', _incrementedValue, ' _percentIncrement=', _percentIncrement, '(1 - _percentIncrement)=', (1 - _percentIncrement), ' _costo_total=', _costo_total, ' _monthlyPayments=', _monthlyPayments);
                        this.quoter.monthly_payment = this.formatPrice(this._monthlyPayments);
                        this.quoter.amount_financing = this.formatPrice(this.roundUpToInteger(this._costo_total - this._incrementedValue));
                        //AQUI VAMOS AGREGAR EL IF PAR EL VUG Y EL R90 setKindPlan.package_id si es igual a 14 y 15 se debe aplicar a la prima_total
                        totalCost = this.roundUpToInteger(this._subTotal + this._iva_subtotal) + xtraD;
                        this.quoter.prima_total = this.formatPrice(this.roundUpToInteger(totalCost));
                    } else {
                        totalCost = this.roundUpToInteger(this._subTotal + this._iva_subtotal) + xtraD;
                        this.quoter.prima_total = this.formatPrice(this.roundUpToInteger(totalCost));
                    }
                }

                this.quoter.prima_neta = this.formatPrice(this.roundUpToInteger(this._prima_neta));
                this.quoter.subtotal = this.formatPrice(this.roundUpToInteger(this._subTotal));
                this.quoter.iva = this.formatPrice(this.roundUpToInteger(this._iva_subtotal));

            } else {
                this.users_count--;
                this.quoter[component]--;
                this.getAlert('no_iva');
            }

        },

        calculateStripeFee(amountNet, months) {
            //console.log('---------------------------------------------------------')
            //console.log('---------------------------------------------------------')
            //console.log('---------------------------------------------------------')
            //console.log("Monto neto:", amountNet, 'meses', months);
            const stripePercentage = 0.036; // 3.6%
            const stripeFixedFee = 3; // 3 MXN
            const taxRate = 0.16; // IVA del 16%
            const msiPercentages = {
                3: 0.05,  // 5% para 3 meses
                6: 0.075, // 7.5% para 6 meses
                9: 0.10,  // 10% para 9 meses
                12: 0.125 // 12.5% para 12 meses
            };

            // Obtener porcentaje adicional por MSI
            const msiRate = Number(months ? msiPercentages[months] || 0 : 0);

            // Calcular la comisión de Stripe (3.6% + tarifa fija) y redondear hacia arriba
            const stripeFee = this.roundUpToInteger((Number(amountNet) * Number(stripePercentage)) + Number(stripeFixedFee));
            //console.log("Comisión Stripe (3.6% + tarifa fija):", stripeFee);

            // Calcular IVA sobre la comisión de Stripe (16%) y redondear hacia arriba
            const stripeFeeIVA = this.roundUpToInteger(stripeFee * taxRate);
            //console.log("IVA sobre la comisión de Stripe (16%):", stripeFeeIVA);

            // Calcular el total de la comisión de Stripe (comisión + IVA) y redondear hacia arriba
            const totalStripeFee = this.roundUpToInteger(stripeFee + stripeFeeIVA);
            //console.log("Comisión total de Stripe (comisión + IVA):", totalStripeFee);

            // Sumar el monto neto al total de la comisión de Stripe para obtener el monto bruto y redondear hacia arriba
            const grossAmountWithoutMSI = this.roundUpToInteger(Number(amountNet) + Number(totalStripeFee));
            //console.log("Monto bruto sin MSI (neto + comisión de Stripe):", grossAmountWithoutMSI);

            // Calcular el porcentaje de MSI (si aplica) y redondear hacia arriba
            const msiFee = this.roundUpToInteger(grossAmountWithoutMSI * msiRate);
            //console.log("Comisión MSI:", msiFee);

            // Calcular IVA sobre el fee de MSI (16%) - CORRECCIÓN APLICADA y redondear hacia arriba
            const msiFeeIVA = this.roundUpToInteger(msiFee * taxRate);
            //console.log("IVA sobre el fee de MSI (16%):", msiFeeIVA);

            // Calcular el total del fee de MSI (fee + IVA) y redondear hacia arriba
            const totalMsiFee = this.roundUpToInteger(msiFee + msiFeeIVA);
            //console.log("Fee total de MSI (fee + IVA):", totalMsiFee);

            // Calcular el monto final (monto bruto con MSI + IVA del MSI) y redondear hacia arriba
            const totalAmount = this.roundUpToInteger(grossAmountWithoutMSI + totalMsiFee);
            //console.log("Monto final con MSI (bruto + fee MSI + IVA MSI):", totalAmount);

            // Calcular pago mensual y redondear hacia arriba
            const monthlyPayment = this.roundUpToInteger(months ? totalAmount / months : totalAmount);

            // Retornar los valores necesarios (ya redondeados)
            return {
                stripeFee: stripeFee,
                stripeFeeIVA: stripeFeeIVA,
                msiFee: msiFee,
                msiFeeIVA: msiFeeIVA,
                totalAmount: totalAmount,
                monthlyPayment: monthlyPayment
            };
        },
        customDiscount() {
            this.calculatePrice(this._global_component);
        },
        changeLimit() {
            this.index();
        },
        closeModal() {
            //console.log('cerrando el modal');
            this.setEmpty();
        },
        decrement(component) {

            //SI EL PLAN ES INDIVIDUAL DEBO VALIDAR QUE SE PUEDA DECREMENTAR EL USUARIO
            if (this.flagIndividual) {
                if (this.users_count > 0) {
                    this.users_count--;
                    this.quoter[component]--;
                }
            } else {
                //SI EL PLAN ES FAMILIAR DEBO DE VALIDAR QUE SE PUEDA DECREMENTAR EL USUARIO
                //console.log('decremento en familiar', this.users_count);
                if (this.users_count > 0) {
                    this.users_count--;
                    this.quoter[component]--;
                }
            }

            this.calculatePrice(component);

        },
        feedFieldsStripe(xtraD) {
            let _orgCost = Number(this._subTotal) + Number(this._iva_subtotal) + Number(xtraD);
            //console.log('feedFieldsStripe-_orgCost=', _orgCost, 'xtraD=', xtraD);
            for (let pago of this.listPagosClip) {
                this.quoter.meses = pago.meses;
                this.quoter.financing_percentage = pago.porcentaje;

                const result = this.calculateStripeFee(_orgCost, pago.id === 4 ? 0 : pago.meses);

                switch (pago.id) {
                    case 4:
                        this.quoter.cash_total = this.formatPrice(result.totalAmount);
                        break;
                    case 2:
                        this.quoter.monthly_payment_of_3_msi = this.formatPrice(result.monthlyPayment);
                        this.quoter.total_3_months = this.formatPrice(result.totalAmount);
                        break;
                    case 3:
                        this.quoter.monthly_payment_of_6_msi = this.formatPrice(result.monthlyPayment);
                        this.quoter.total_6_months = this.formatPrice(result.totalAmount);
                        break;
                    case 10:
                        this.quoter.monthly_payment_of_9_msi = this.formatPrice(result.monthlyPayment);
                        this.quoter.total_9_months = this.formatPrice(result.totalAmount);
                        break;
                    case 1:
                        this.quoter.monthly_payment_of_12_msi = this.formatPrice(result.monthlyPayment);
                        this.quoter.total_12_months = this.formatPrice(result.totalAmount);
                        break;
                }
            }
        },
        formatPrice(value) {

            //console.log('tiene el signo de pesos', value, '-', this.detectDollar(value));
            if (this.detectDollar(value) === false) {

                let val = (value / 1).toFixed(2).replace(',', '.')
                return '$' + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

            } else {

                return value;
            }

        },
        enableFields() {
            this.isPagoIdEnabled = true;
            this.activateFieldKids = true;
            this.activateFieldsEmb = true;
            this.activateFieldsAdult = true;
            this.activateFieldsGranny = true;
        },
        getInfoPagoIdInEdit(pago_id) {
            //console.log('pago_id', pago_id, 'pagos', this.pagos);
            for (let pago of this.pagos) {
                if (pago_id === pago.id) {
                    //console.log('meses', pago.meses);
                    this.quoter.financing_percentage = pago.financing_percentage;
                    this.quoter.meses = pago.meses;
                    //console.log('quoter', this.quoter);

                }
            }
        },
        getInfoPlanSelectedInEdit(currentPlanId) {
            for (let plan of this.plans) {
                if (currentPlanId === plan.id) {
                    this.activateFieldQuoter(+plan.min_per);
                }
            }
        },
        getMonths($e) {
            //console.log('value del getMonths', $e.target.options[$e.target.options.selectedIndex].value);
            if ($e.target.options[$e.target.options.selectedIndex].value == 12) {
                switch (Number(this.setKindPlan.kind_plan)) {
                    case 1:
                    case 2:
                        //AQUI VAMOS A DETECTAR QUE QUIEREN UNA COTIZACIÓN MOSTRANDO LAS CANTIDAD DE FINANCIAMIENTO POR CLIP
                        //PRIMERO DESAPARESCO LOS CAMPOS DE LOS TOTALES
                        this.showAffiliates = true;
                        //DESAPARESCO LOS CAMPOS DE COLECTIVOS
                        this.showCollectiveFields = false;
                        //LA VARIABLE clip_budget ME DIRA QUE DEBO HACER EN LA FUNCION DEL CALCULO DE PRECIOS
                        this.clip_budget = true;
                        //ACTIVO LOS CAMPOS DE LOS TOTALES DE CLIP
                        this.showClipFields = true;
                        //this.calculatePrice(this._global_component);
                        break;
                    case 3:
                        this.showAffiliates = false;
                        this.showCollectiveFields = true;
                        this.clip_budget = true;
                        this.showClipFields = true;
                        break;
                }

            } else {
                this.showClipFields = false;
                this.clip_budget = false;
                this.quoter.financing_percentage = $e.target.options[$e.target.options.selectedIndex].getAttribute('data-porcentaje');
                this.quoter.meses = $e.target.options[$e.target.options.selectedIndex].getAttribute('data-meses');
                this.quoter.visible_for = $e.target.options[$e.target.options.selectedIndex].getAttribute('data-visible');
            }

            this.activateFieldQuoter(+this.setKindPlan.min_per);

        },
        handleBlur() {
            if (this.quoter.prima_total) {
                const cleanedValue = this.rawPrice(this.quoter.prima_total);
                this.quoter.prima_total = parseFloat(cleanedValue);
                //this.calculatePrice();
            }
        },
        handleInput(fieldName) {

            this.quoter[fieldName] = this.quoter[fieldName].replace(/[^\d.]/g, '');

            const parts = this.quoter[fieldName].split('.');
            if (parts.length > 2) {
                this.quoter[fieldName] = parts[0] + '.' + parts.slice(1).join('');
            }

        },
        increment(component) {
            //SI EL PLAN ES INDIVIDUAL DEBO DE VALIDAR QUE SE PUEDA INCREMENTAR EL USUARIO
            if (this.flagIndividual) {
                this.users_count++;
                this.quoter[component]++;
                //console.log('incremento en individual', this.users_count, 'this.quoter[component]', this.quoter[component]);

            } else {
                //SI EL PLAN ES FAMILIAR DEBO DE VALIDAR QUE SE PUEDA INCREMENTAR EL USUARIO
                if (this.users_count > (this.setKindPlan.min_per - 1)) {
                    //console.log('no se puede incrementar mas usuarios');
                    this.getAlert('maximum');
                } else {
                    this.users_count++;
                    this.quoter[component]++;
                    //console.log('incremento en familiar', this.users_count, 'this.quoter[component]', this.quoter[component]);
                }
            }

            this.calculatePrice(component);

        },
        onChange(page) {
            this.params.page = page;
            this.index();
        },
        rawPrice(price) {
            if (/\$|,/.test(price)) {
                return price.replace(/\$|,/g, '');
            }
            return price;
        },
        renew_quoter(item) {
            this.quoting_id = item.id;
            this.openModalsProviders('renew_quoter');
        },
        setEmpty() {
            this.isKindPlanIdEnabled = false;
            this.isPercentIvaEnabled = false;
            this.isPagoIdEnabled = false;
            this.showCustomMonth = false
            this.showTotales = false;
            this.showCollectiveFields = false;
            this.showClipFields = false;
            this.showAffiliates = false;
            this.showModal = false;
            this.showModGran = false;
            this.flagGran = false;
            this.flagIndividual = false;
            this.isBusy = false;
            this.modificar = false;
            this.filter = null;
            this.activateFieldKids = true;
            this.activateFieldsEmb = true;
            this.activateFieldsAdult = true;
            this.activateFieldsGranny = true;
            this.renew_status = 0;
            this.quoter = {
                nota: '',
                wellmedic: '',
                saluddigna: '',
                state_id: 0,
                cities_id: 0,
                promoter_id: 0,
                agent_id: 0,
                package_id: 0,
                kind_plan_id: 0,
                pago_id: 0,
                tipo_per: 0,
                nom_cont: '',
                paterno: '',
                materno: '',
                direccion: '',
                telefono: '',
                email: '',
                nmComPerMoral: '',
                rfc: '',
                tel_asesor: '',
                email_asesor: '',
                num_afil: 0,
                costo_x_persona: 0,
                costo_x_per_dcto: 0,
                percent_iva: 0,
                financing_percentage: 0,
                prima_base: '',
                extra_prima: '',
                desc_fam: '',
                prima_neta_desc: '',
                prima_neta: '',
                gastos: '',
                gasto_x_persona: '',
                subtotal: '',
                iva: '',
                prima_total: '',
                prima_total_clip: '',
                kid: 0,
                emb: 0,
                adu: 0,
                gran: 0,
                prima_base_am: 0,
                extra_prima_am: 0,
                desc_fam_am: 0,
                prima_neta_am: 0,
                gastos_am: 0,
                subtotal_am: 0,
                iva_am: 0,
                prima_total_am: 0,
                num_titulares: '',
                num_dependientes: '',
                num_asegurados: '',
                descuento: '',
                a_p: '',
                financiamiento: '',
                anticipo: '',
                renovar: '',
                client_id: 0,
                meses: 0,
                visible_for: 0,
                add_gran: 0,
                amount_financing: 0,
                monthly_payment: 0,
                payment_date: '',
                start_date: '',
                end_date: '',
                cash_total: 0,
                total_3_months: 0,
                monthly_payment_of_3_msi: 0,
                monthly_payment_of_6_msi: 0,
                total_6_months: 0,
                monthly_payment_of_9_msi: 0,
                total_9_months: 0,
                monthly_payment_of_12_msi: 0,
                total_12_months: 0,
                apportionment: false,
            };
            this.quoter_id_ticket = 0;
            this.approved_at = false;
            this.params = {
                limit: 10,
                page: 1,
                where: []
            };
            this.setKindPlan = {
                id: 0,
                package_id: '',
                min_per: '',
                kind_plan: '',
                descuento: 0,
                gasto: 0,
                vug: 0,
                r90: 0,
            };
            this.kindFiled = '';
            this.planSelected = '';
            this.min_p = 0;
            this.itemId = 0;
            this.users_count = 0;
            this.quoting_id = 0;
            this._global_component = '';
            this.clip_budget = false;
            this.listPagosClip = [];
            this._incrementedValue = 0;
            this._percentIncrement = 0;
            this._costo_total = 0;
            this._monthlyPayments = 0;
            this._pb = 0;
            this._gasto = 0;
            this._iva = 0;
            this._percent_increment = 0;
            this._sumPercentRule = 0;
            this._prima_neta = 0;
            this._subTotal = 0;
            this._calDescPb = 0;
            this._calPercentDesc = 0;
            this._iva_subtotal = 0;
        },
        settingKindPlan($e) {
            //DESACTIVO LOS CAMPOS DE CLIP SI ESTAN ACTIVOS
            this.showClipFields = false;
            this.isPercentIvaEnabled = true;
            let itemSelected = $e.target.options[$e.target.options.selectedIndex];
            //console.log('itemSelected',itemSelected.value);
            this.setKindPlan.package_id = itemSelected.getAttribute('data-package-id');
            this.setKindPlan.min_per = itemSelected.getAttribute('data-min-per');
            this.setKindPlan.kind_plan = itemSelected.getAttribute('data-kind-plan');
            this.setKindPlan.descuento = itemSelected.getAttribute('data-descuento');
            this.setKindPlan.gasto = itemSelected.getAttribute('data-gasto');
            this.setKindPlan.costo = itemSelected.getAttribute('data-costo');
            this.setKindPlan.vug = itemSelected.getAttribute('data-vug');
            this.setKindPlan.r90 = itemSelected.getAttribute('data-r90');
            //this.activateFieldQuoter(+this.setKindPlan.min_per);
        },
        tipoPer($e) {

            let per = this.stateId($e);
            //console.log('_per', per);
            const _nmComPerMoral = document.querySelector('#nmComPerMoral');
            const _nombre = document.querySelector('#nombre');
            const _paterno = document.querySelector('#paterno');
            const _materno = document.querySelector('#materno');

            switch (+per) {
                case 1:
                    //console.log('FISICA');
                    _nombre.classList.add('required');
                    _paterno.classList.add('required');
                    _materno.classList.add('required');
                    _nmComPerMoral.classList.remove('required');
                    break;

                case 2:
                    //console.log('MORAL', $e.target.value);
                    //PERSONA MORAL
                    _nombre.classList.remove('required');
                    _paterno.classList.remove('required');
                    _materno.classList.remove('required');
                    _nmComPerMoral.classList.add('required');

                    break;

            }
        },
        uploadInvoice(id) {
            this.quoting_id = id;
            //console.log('quoting_id', this.quoting_id);
            this.openModalsProviders('invoice_quoter_agent')
        },
    },
    mounted() {
        this.index();
    },
}
</script>

<style scoped>
.reservation-box {
    background-color: #f1f1f1;
    border-radius: 15px;
    box-shadow: 0 0 10px rgba(0, 0, 0, .1);
    margin-bottom: 20px;
    padding: 15px;
    text-align: center;
}

.reservation-box .person-counter .titleCounter {
    border-bottom: 1px solid #e3e3e3;
    font-size: 12px;
    letter-spacing: .1rem;
    margin-bottom: 14px;
    margin-right: 10px;
    margin-top: 5px;
    padding-bottom: 10px;
    text-transform: uppercase;
}

.reservation-box .person-counter .amount {
    height: 25px;
    line-height: 26px;
    margin: 0 5px;
}

.reservation-box .person-counter .button {
    background-color: #fff;
    border: 0;
    border-radius: 15px;
    color: #000;
    display: inline-block;
    font-size: 14px;
    height: 25px;
    line-height: 27px;
    text-align: center;
    width: 25px;
    vertical-align: baseline;
}

.reservation-box .person-counter span.amount {
    display: inline-block;
    font-size: 14px;
    text-align: center;
    vertical-align: bottom;
}
</style>
